"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var styles = require("./SimpleModal.scss");
var SimpleModalProps_1 = require("./SimpleModalProps");
var SimpleModalStylesMaps_1 = require("./SimpleModalStylesMaps");
var utils_1 = require("../../../utils/utils");
var SimpleModal = /** @class */ (function (_super) {
    __extends(SimpleModal, _super);
    function SimpleModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tabElements = null;
        _this.firstEl = null;
        _this.lastEl = null;
        _this.previousEl = null;
        _this.state = {
            escaped: false,
            shown: false,
            transition: _this.props.show ? styles.nModalOverylayOpen : styles.nModalOverylayClose,
            transitioning: false,
        };
        _this.addEscapeListener = function () {
            utils_1.ssrSafe(function () {
                if (window && window.addEventListener) {
                    window.addEventListener("keydown", _this.onEscape, false);
                }
            });
        };
        _this.removeEscapeListener = function () {
            utils_1.ssrSafe(function () {
                if (window && window.removeEventListener) {
                    window.removeEventListener("keydown", _this.onEscape, false);
                }
            });
        };
        _this.componentWillUnmount = function () {
            utils_1.ssrSafe(function () {
                if (document && document.documentElement) {
                    document.documentElement.classList.remove("overflow-hidden");
                }
                _this.removeEscapeListener();
            });
            _this.removeFocusListener();
        };
        _this.componentDidUpdate = function () {
            var _a = _this.props, disableOnFocus = _a.disableOnFocus, fade = _a.fade, focusFirstElement = _a.focusFirstElement, show = _a.show;
            var _b = _this.state, escaped = _b.escaped, shown = _b.shown, transition = _b.transition, transitioning = _b.transitioning;
            if (fade && show && !shown && transition !== styles.nModalOverylayOpen) {
                _this.setState({ transition: styles.nModalOverylayClose, transitioning: true });
            }
            if (fade && show && transitioning && transition === styles.nModalOverylayClose) {
                _this.setState({ transition: styles.nModalOverylayOpen });
            }
            if (escaped) {
                _this.onClose();
            }
            if (show && _this.containerRef && !escaped) {
                if (_this.modalRef) {
                    _this.tabElements = _this.modalRef.querySelectorAll('input, button, a, select, textarea, div[tabindex="0"], div[role="button"]:not([aria-hidden=true]), div[role="checkbox"]:not([aria-hidden=true]), div[role="radio"]:not([aria-hidden=true])');
                    _this.firstEl = _this.tabElements[0];
                    _this.lastEl = _this.tabElements[_this.tabElements.length - 1];
                    if (!shown) {
                        if (disableOnFocus !== true) {
                            _this.addFocusListener();
                        }
                        else {
                            _this.removeFocusListener();
                        }
                    }
                    if (!shown && !transitioning) {
                        if (focusFirstElement && _this.firstEl) {
                            _this.firstEl.focus();
                        }
                        else {
                            _this.containerRef.focus();
                        }
                        _this.setState({ shown: true });
                    }
                }
            }
        };
        _this.addFocusListener = function () {
            utils_1.ssrSafe(function () {
                if (document && document.addEventListener) {
                    document.addEventListener("focus", _this.onFocus, true);
                }
            });
        };
        _this.removeFocusListener = function () {
            utils_1.ssrSafe(function () {
                if (document && document.removeEventListener) {
                    document.removeEventListener("focus", _this.onFocus, true);
                }
            });
        };
        _this.onFocus = function (e) {
            var _a;
            var disableOnFocus = _this.props.disableOnFocus;
            if (disableOnFocus !== true) {
                var c_1 = false;
                if (_this.tabElements && _this.tabElements.length > 0) {
                    _this.tabElements.forEach(function (item) {
                        if (item === e.target) {
                            item.focus();
                            _this.previousEl = item;
                            c_1 = true;
                            return;
                        }
                    });
                    if (!c_1 && e.target !== _this.containerRef && !((_a = _this.containerRef) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
                        if (_this.previousEl === _this.firstEl) {
                            _this.lastEl.focus();
                        }
                        else {
                            _this.firstEl.focus();
                        }
                    }
                }
            }
        };
        _this.onTab = function (e, ref, shift) {
            if (e.which === 9 && shift) {
                e.preventDefault();
                ref.focus();
            }
        };
        _this.onClose = function (e) {
            _this.removeFocusListener();
            _this.setState({
                shown: false,
                transition: styles.nModalOverylayClose,
                transitioning: _this.props.fade ? true : false,
                escaped: false,
            });
            if (_this.wasFocused) {
                _this.wasFocused.focus();
                _this.wasFocused = undefined;
            }
            var close = _this.props.close;
            if (close) {
                close(e);
            }
        };
        _this.onEscape = function (e) {
            var noEscape = _this.props.noEscape;
            if (!noEscape && e.key === "Escape") {
                _this.setState({ escaped: true });
            }
        };
        _this.childClick = function (e) {
            e.stopPropagation();
        };
        _this.handleTransEnd = function () {
            _this.setState({ transitioning: false });
        };
        _this.render = function () {
            var _a = _this.props, accessibilityTitle = _a.accessibilityTitle, children = _a.children, closeButtonAccessibilityText = _a.closeButtonAccessibilityText, closeButtonClass = _a.closeButtonClass, closeHidden = _a.closeHidden, containerClass = _a.containerClass, contentClass = _a.contentClass, describedbyId = _a.describedbyId, fade = _a.fade, labelledbyId = _a.labelledbyId, propsRoot = _a.root, show = _a.show, propsSize = _a.size, propsSizing = _a.sizing, testId = _a.testId;
            utils_1.ssrSafe(function () {
                var _a = _this.state, escaped = _a.escaped, shown = _a.shown;
                if (document && document.documentElement && document.getElementById) {
                    var root = document.getElementById(propsRoot ? propsRoot : "root");
                    if (show) {
                        if (!_this.wasFocused) {
                            _this.wasFocused = document.activeElement || undefined;
                        }
                        if (root) {
                            root.setAttribute("aria-hidden", "true");
                        }
                        document.documentElement.classList.add("overflow-hidden");
                        if (!shown && !escaped) {
                            _this.addEscapeListener();
                        }
                    }
                    else {
                        if (_this.wasFocused) {
                            _this.wasFocused.focus();
                            _this.wasFocused = undefined;
                        }
                        if (root) {
                            root.removeAttribute("aria-hidden");
                        }
                        document.documentElement.classList.remove("overflow-hidden");
                        _this.removeEscapeListener();
                    }
                }
            });
            var _b = _this.state, transition = _b.transition, transitioning = _b.transitioning;
            var size = propsSize ? propsSize : SimpleModalProps_1.SimpleModalSize.MEDIUM;
            var sizing = propsSizing ? propsSizing : undefined;
            var renderModal = function () {
                return ((show || transitioning) && (React.createElement("div", { "data-testid": testId, onMouseDown: _this.onClose, onTransitionEnd: fade ? _this.handleTransEnd : undefined, ref: function (ref) {
                        _this.modalRef = ref;
                    }, className: [
                        fade ? transition : "",
                        containerClass,
                        styles.nModal,
                        "height-full left top block",
                    ].join(" ") },
                    React.createElement("div", { "aria-modal": true, tabIndex: -1, "aria-labelledby": labelledbyId, "aria-describedby": describedbyId, "aria-label": accessibilityTitle, role: "dialog", onMouseDown: _this.childClick, ref: function (ref) {
                            _this.containerRef = ref;
                        }, className: [
                            _this.getSizing(sizing),
                            contentClass,
                            _this.getSize(size),
                            styles.nModalContent,
                            "overflow-y-auto overflow-hidden rel bg-ui-white",
                        ].join(" ") },
                        !closeHidden && (React.createElement("button", { type: "button", "aria-label": closeButtonAccessibilityText || 'Close', onClick: _this.onClose, name: "close", className: [
                                "min-width-sm-all pad-none-all icon-close absolute color-ui-black",
                                closeButtonClass,
                                styles.nCloseButton,
                                "bg-ui-white absolute bg-ui-white",
                            ].join(" ") })),
                        children))));
            };
            if (typeof document !== "undefined") {
                return ReactDOM.createPortal(renderModal(), document.body);
            }
            return renderModal();
        };
        return _this;
    }
    SimpleModal.prototype.getSize = function (size) {
        if (size) {
            return SimpleModalStylesMaps_1.sizeMap.get(size);
        }
    };
    SimpleModal.prototype.getSizing = function (sizing) {
        if (sizing) {
            return SimpleModalStylesMaps_1.sizingMap.get(sizing);
        }
    };
    return SimpleModal;
}(React.Component));
exports.default = SimpleModal;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/containers/SimpleModal/SimpleModal.js
// module id = 1675
// module chunks = 8